import {
  IAnalyticsDashboardArgument,
  IAnalyticsDashboardProperties,
  IDashboardEventSubParams,
} from './types';
import { IAnalyticsEntityPermission, IAnalyticsObjectOwner } from '../../types';
import {
  EntityRole,
  IEntityRoleAssignmentFieldsFragment,
} from '../../../apollo/graphqlSchema';
import { getAnalyticsUser } from '../user/utils';

const roleAnalyticsKey = {
  EDITOR: 'editors',
  MANAGER: 'managers',
  OWNER: 'owners',
  VIEWER: 'viewers',
} as const satisfies Record<EntityRole, string>;

const mapRoleAssignment = (
  ra: IEntityRoleAssignmentFieldsFragment,
): IAnalyticsEntityPermission => {
  return {
    users: ra.users.map(getAnalyticsUser),
  };
};

const getDashboardOwner = (
  dashboard: IAnalyticsDashboardArgument,
): IAnalyticsObjectOwner => {
  const permission = dashboard.permission;
  const owner: IAnalyticsObjectOwner = {};

  for (let roleAssignment of permission.roleAssignments) {
    const roleKey = roleAnalyticsKey[roleAssignment.role];
    owner[roleKey] = mapRoleAssignment(roleAssignment);
  }

  return owner;
};

const hasDashboardFilter = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
) => {
  if (
    'filter' in dashboardInstanceOrTemplate &&
    dashboardInstanceOrTemplate.filter
  ) {
    const { filter: dashboardFilter } = dashboardInstanceOrTemplate;
    return dashboardFilter.filter
      ? dashboardFilter.filter.conditions.length > 0
      : false;
  } else {
    return false;
  }
};

export const getDashboardEventProperties = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
  subParams?: IDashboardEventSubParams,
): IAnalyticsDashboardProperties => {
  return {
    object_type: 'dashboard',
    object_name: dashboardInstanceOrTemplate.name,
    object_owner: getDashboardOwner(dashboardInstanceOrTemplate),
    object_id: dashboardInstanceOrTemplate.baseId,
    has_filter: hasDashboardFilter(dashboardInstanceOrTemplate),
    is_embedded: subParams?.isEmbedded ?? false,
    new_comment_target: subParams?.newCommentTarget ?? '',
    new_comment_has_mention: subParams?.hasMention ?? false,
    new_comment_has_emoji: subParams?.hasEmoji ?? false,
  };
};
